<template>
  <v-card-text
    v-show="selected() || hasComments()"
    :id="listElementId"
    :key="item.id"
    class="p-commentListWrapper p-commentListWrapperForm"
    :class="{
      'p-commentListWrapper__selected': selected(),
      'p-commentListWrapperForm__selected': selected() || hasComments(),
    }"
    @click="selectCommentItem"
  >
    <v-card
      class="p-commentList"
      :class="{ 'p-commentList__selected': selected() }"
      outlined
    >
      <v-system-bar v-if="selected()" class="pt-2" color="transparent">
        <v-spacer></v-spacer>
        <v-icon medium @click.stop="closeAction"> mdi-close </v-icon>
      </v-system-bar>
      <comment-display
        v-if="hasComments()"
        :item="item"
        :comment="itemComments[0]"
      />
      <comment-form v-else :item="item" :method="'post'" />
      <v-card-actions v-if="hasComments()">
        <span
          v-if="itemComments[1]"
          class="body-2 font-weight-medium pl-3"
          style="color: #0b4c8c"
        >
          他{{ hiddenComments().length }}件のコメント
        </span>
        <v-btn color="grey darken-2" text @click.stop="show = !show">
          <span v-if="itemComments[1]" class="caption">{{
            show ? 'スレッドを閉じる' : 'スレッドを表示する'
          }}</span>
          <span v-else class="caption">{{
            show ? 'フォームを閉じる' : 'コメントをする'
          }}</span>
        </v-btn>
      </v-card-actions>
      <v-expand-transition v-if="hasComments()">
        <div v-show="show">
          <v-divider class="mx-2"></v-divider>
          <comment-under :item="item" :comments="hiddenComments()" />
          <comment-form :item="item" :method="'post'" />
        </div>
      </v-expand-transition>
    </v-card>
  </v-card-text>
</template>

<script>
import CommentDisplay from '@/components/postEditor/parts/comments/CommentDisplay'
import CommentUnder from '@/components/postEditor/parts/comments/CommentUnder'
import CommentForm from '@/components/postEditor/parts/comments/CommentForm'
import { mapState } from 'vuex'

export default {
  components: {
    CommentDisplay,
    CommentUnder,
    CommentForm
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      listElementId: 'comment_list' + this.item.id,
      show: false,
      itemComments: this.item.itemComments,
      toolbarElementId: 'rightToolBar',
      contentscrollbarElementId: 'p-postEditor__content-field'
    }
  },
  computed: {
    ...mapState({
      selectedCommentItem: (state) => state.PostEditor.selectedCommentItem
    })
  },
  mounted () {
    this.selectedCommentAction()

    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'PostEditor/ADD_NEW_ITEM_COMMENT':
          if (mutation.payload.itemUuid === this.item.uuid) {
            this.postedCommentAction(state)
          }
          break
        case 'PostEditor/SET_SELECTED_COMMENT_ITEM':
          if (mutation.payload && mutation.payload.uuid === this.item.uuid) {
            this.selectedCommentAction()
            this.scrollSelectedPreviewItem()
          }
          break
        case 'PostEditor/UPDATE_ITEM_COMMENT':
          if (mutation.payload.itemUuid === this.item.uuid) {
            this.fetchItemComments(state)
          }
          break
        case 'PostEditor/DELETE_ITEM_COMMENT':
          if (mutation.payload.itemUuid === this.item.uuid) {
            this.fetchItemComments(state)
          }
          break
      }
    })
  },
  methods: {
    selected () {
      return (
        !!this.selectedCommentItem &&
        this.selectedCommentItem.uuid === this.item.uuid
      )
    },
    selectCommentItem () {
      if (!this.selected()) {
        this.$store.commit('PostEditor/SET_SELECTED_COMMENT_ITEM', this.item)
      }
    },
    hasComments () {
      return !!this.itemComments && this.itemComments.length !== 0
    },
    postedCommentAction (state) {
      this.itemComments = state.PostEditor.post.items.find(
        (item) => item.uuid === this.item.uuid
      ).itemComments
      this.show = true
    },
    selectedCommentAction () {
      if (this.selected()) {
        setTimeout(this.scrollSelectedComments, 100)
        this.show = true
      }
    },
    scrollSelectedComments () {
      const scrollValue = this.calcScrollYValue()
      document
        .getElementById(this.toolbarElementId)
        .scrollTo({ top: scrollValue, behavior: 'smooth' })
    },
    calcScrollYValue () {
      // スクロールさせるコメントリストをwindowの絶対位置を利用して計算する
      const scrollTargetTop = document
        .getElementById(this.listElementId)
        .getBoundingClientRect().top
      const parentTop = document
        .getElementById(this.toolbarElementId)
        .getBoundingClientRect().top
      const firstItemTop = document
        .getElementById(this.toolbarElementId)
        .children[0].getBoundingClientRect().top
      const headerHeight = document.getElementById('mainHeader').clientHeight

      return (
        scrollTargetTop -
        firstItemTop -
        (parentTop <= headerHeight - 20 ? headerHeight : 0)
      )
    },
    closeAction () {
      this.$store.commit('PostEditor/SET_SELECTED_COMMENT_ITEM', null)
      this.show = false
    },
    hiddenComments () {
      return this.itemComments.slice(1)
    },
    fetchItemComments (state) {
      return (this.itemComments = state.PostEditor.post.items
        .find((item) => item.id === this.item.id)
        .itemComments.slice(0))
    },
    scrollSelectedPreviewItem () {
      if (document.getElementsByClassName('p-itemList__item')[this.index]) {
        const scrollValue = this.calcScrollPreviewItemsYValue()
        document
          .getElementById(this.contentscrollbarElementId)
          .scrollTo({ top: scrollValue, behavior: 'smooth' })
      }
    },
    calcScrollPreviewItemsYValue () {
      const scrollTargetTop = document
        .getElementsByClassName('p-itemList__item')[this.index]
        .getBoundingClientRect().top
      const firstItemTop = document
        .getElementById(this.contentscrollbarElementId)
        .children[0].getBoundingClientRect().top
      const parentTop = document
        .getElementById(this.contentscrollbarElementId)
        .getBoundingClientRect().top
      const headerHeight = document.getElementById('mainHeader').clientHeight
      return (
        scrollTargetTop -
        firstItemTop -
        (parentTop <= headerHeight - 20 ? headerHeight : 0)
      )
    }
  }
}
</script>

<style scoped>
.p-commentListWrapper {
  max-width: 300px;
  display: block;
  transition: all 0.5s;
  margin-left: 20px;
}

.p-commentList {
  display: block;
  transition: all 0.5s;
}

.p-commentListWrapper__selected {
  margin-left: -10px;
}

.p-commentListWrapperForm {
  opacity: 0;
}

.p-commentListWrapperForm__selected {
  display: block;
  opacity: 1;
  animation-duration: 0.5s;
  animation-name: fade-in;
  -moz-animation-duration: 0.5s;
  -moz-animation-name: fade-in;
  -webkit-animation-duration: 0.5s;
  -webkit-animation-name: fade-in;
}

.p-commentList__selected {
  box-shadow: 10px 8px 10px 3px #ccc;
}

@keyframes fade-in {
  0% {
    display: none;
    opacity: 0;
  }

  1% {
    display: block;
    opacity: 0;
  }

  100% {
    display: block;
    opacity: 1;
  }
}
</style>
